import { PicturePack, PicturesDataset } from "@tblabs/storage";
import { Div, RefBool, MultipleFilesInput, Link, Snack } from "@tblabs/truffle";
import { PrimaryButton } from "../Components/PrimaryButton";


export class PicsUploader extends Div
{
    private onSuccessfulUpload?: (pictures: PicturePack[]) => void;

    constructor(dataset: PicturesDataset)
    {
        super("add-field-box");

        const showUploader = new RefBool(false);

        this.Append(
            new PrimaryButton("Add pictures")
                .OnClick(async () => showUploader.True())
                .Invisible(showUploader),
            new MultipleFilesInput(async (files: File[]) =>
            {
                new Snack("Upload started", files.length + " files");

                try
                {
                    const uploadedPictures = await dataset.Add(files) as PicturePack[];

                    new Snack("Upload finished", uploadedPictures.length + " files uploaded");

                    this.onSuccessfulUpload?.(uploadedPictures);
                }
                catch (error: any)
                {
                    console.error(error);
                    new Snack("Upload failed", error.message, { autoCloseTimeout: 0 });
                }
                finally
                {
                    showUploader.False();
                }
            }).Visible(showUploader),
            new Link("×").FontSize(20).Color("red").Bold().CursorPointer().Style(`transform: translate(-16px, -12px);`).OnClick(() => showUploader.False())
                .Visible(showUploader)
        );
    }

    public OnSuccessfulUpload(onSuccessfulUpload: (pictures: PicturePack[]) => void): this
    {
        this.onSuccessfulUpload = onSuccessfulUpload;

        return this;
    }
}
